<template>
  <div class="productAlterBox">
    <ul>
      <li class="liList">
        <div class="box" >
          <div id="chain123"  class="mainChain" style="width: 100%;height:100%;"></div>
        </div>
      </li>
      <li v-for="(item,index) in indexSearchInfo" :key="index" class="liList">
        <!--[左侧关系图谱 start]-->
        <div class="box">
          <!-- 为 ECharts 准备一个具备大小（宽高）的 DOM -->
          <div :id="'main'+index" class="main" style="width: 100%;height:100%;"></div>
        </div>
        <!--[左侧关系图谱 end]-->

        <!--[右侧图表展示 start]-->
        <div class="box" >
          <!-- 为 ECharts 准备一个具备大小（宽高）的 DOM -->
          <div :id="'mainLine'+index" class="mainLine" style="width: 100%;height:100%;"></div>
        </div>
        <!--[右侧图表展示 end]-->
      </li>
    </ul>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import ssUtil from '@/utils/SStorage'
  import $ from 'jquery'
  import baseUrl from '../utils/setting'
  export default {
    name: 'productAlter',
    data() {
      return {
        productChain: {},
        productAlterInfo: [],
        productLineInfo:[],
      }
    },
    computed: {...mapState(['indexSearchInfo','productRouterInfo','colorArr','coreName'])},
    created(){},
    methods: {
        //增加详情操作记录
        addHistoryOpeParam(params){
            this.$store.dispatch('addHistoryOpeParam',{opeParam:JSON.stringify(params)}).then( res => {
                if( res.data.retCode == '000' ){}
            })
        },
        //展示关系图
        showGraph(){
            let that = this, elList=[], myChart = [],codeList=[];
            // let color = ['#b44c53', '#82778d', '#ba774a', '#55787f', '#ca9f51', '#667c92', '#88739e', '#8d8d85', '#678265', '#827865', '#ac7a79', '#bebeab', '#9cabbd', '#748596', '#87919e', '#706777', '#baac92', '#919382'];
            let color = ['#586d82', '#ba774a'];
            this.indexSearchInfo.forEach(function(item, index){
                let data = [], links = [];
                // data.push({
                //     value: item.securityName,
                //     name: item.securityName,
                //     symbolSize: 50,
                //     draggable: true,
                //     typeFlag: 'company',
                //     securityName: item.securityName,
                //     securityCode: item.securityCode,
                //     coCode: item.coCode,
                //     seriesCode:item.seriesCode,
                //     itemStyle: {
                //         normal: {
                //             color: that.colorArr[0]
                //         }
                //     }
                // }),
                data.push({
                    value: item.productName,
                    name: item.productName,
                    seriesDataList: item.seriesDataList,
                    productCode: item.productCode,
                    seriesCode: item.seriesCode,
                    companyList: item.companyList,
                    seriesName: item.seriesName,
                    minValue: item.minValue,
                    maxValue: item.maxValue,
                    productName: item.productName,
                    industry: item.industry,
                    symbolSize: 50,
                    draggable: true,
                    typeFlag: 'company',
                    itemStyle: {
                        normal: {
                            color: that.colorArr[4]
                        }
                    }
                }),
                codeList.push(item.productCode)
                // item.productList.forEach( function( it ){
                //     data.push({
                //         value: it.productName,
                //         name: it.productName,
                //         symbolSize: it.productSort<=4?20+(4-it.productSort)*10:20,
                //         typeFlag: 'product',
                //         productName: it.productName,
                //         productCode: it.productCode,
                //         industry: it.industry,
                //         coCode: item.coCode,
                //         remark: it.remark,
                //         minValue: it.minValue,
                //         maxValue: it.maxValue,
                //         itemStyle: {
                //             normal: {
                //                 color: that.colorArr[it.productSort]
                //             }
                //         }
                //     }),

                //     links.push({
                //         source: item.securityName,
                //         target: it.productName
                //     })
                // })
                item.companyList.forEach(function(it) {
                    data.push({
                        value: it.securityName,
                        name: it.securityName,
                        securityName: it.securityName,
                        coCode: it.coCode,
                        securityCode: it.securityCode,
                        // symbolSize: it.productSort<=4?20+(4-it.productSort)*10:20,
                        typeFlag: 'product',
                        itemStyle: {
                            normal: {
                                // color: that.colorArr[it.productSort]
                                // color: color[index]
                                color: that.colorArr[3]
                            }
                        }
                    }),
                    links.push({
                        source: item.productName,
                        target: it.securityName
                    })
                })
                var option = {
                    title: {text: ''},
                    tooltip: {
                        show: true,
                        trigger: 'item'
                    },
                    animation:false,
                    animationEasingUpdate: 'quinticInOut',
                    series: [
                    {
                        type: 'graph',
                        layout: 'force',
                        symbol: 'circle',
                        symbolSize: 30,
                        draggable: false,
                        roam: false,
                        cursor:'pointer',
                        label: {
                            normal: {
                                show: true,
                                fontWeight: 500,
                                fontSize: 16,
                                position:'top',
                                color:'#333',
                            },
                        },
                        force: {
                            // 力引导布局相关的配置项，力引导布局是模拟弹簧电荷模型在每两个节点之间添加一个斥力，每条边的两个节点之间添加一个引力，每次迭代节点会在各个斥力和引力的作用下移动位置，多次迭代后节点会静止在一个受力平衡的位置，达到整个模型的能量最小化。
                            // 力引导布局的结果有良好的对称性和局部聚合性，也比较美观。
                            repulsion: 850, // [ default: 50 ]节点之间的斥力因子(关系对象之间的距离)。支持设置成数组表达斥力的范围，此时不同大小的值会线性映射到不同的斥力。值越大则斥力越大
                            edgeLength: 150 // [ default: 30 ]边的两个节点之间的距离(关系对象连接线两端对象的距离,会根据关系对象值得大小来判断距离的大小)，
                            // 这个距离也会受 repulsion。支持设置成数组表达边长的范围，此时不同大小的值会线性映射到不同的长度。值越小则长度越长。如下示例:
                            // 值最大的边长度会趋向于 10，值最小的边长度会趋向于 50      edgeLength: [10, 50]
                        },
                        edgeSymbol: ['circle', 'arrow'],
                        edgeSymbolSize: [4, 10],
                        data: data,
                        tooltip: {
                            // formatter: '{b}',
                            formatter: function(params){//触发之后返回的参数，这个函数是关键
                                // console.log(params);
                                if (params.data.typeFlag == 'product' ) {//如果触发节点
                                    return  params.data.remark;//返回标签
                                }else if( params.data.typeFlag == 'company'){
                                    return  params.data.name;
                                }
                            },
                            backgroundColor: 'rgba(50,50,50,0.8)'
                        },
                        links: links,
                        lineStyle: {
                            normal: {
                                opacity: 0.5,
                                width: 1,
                                curveness: 0
                            }
                        }
                    }
                    ]
                };
                that.productAlterInfo.push(option)
            })
            // 基于准备好的dom，初始化echarts实例
            this.$nextTick(function(){
                elList = document.querySelectorAll('.productAlterBox>ul>li:not(:first-child)')
                for(var i=0;i< elList.length;i++ ){
                    myChart.push( that.$echarts.init( document.getElementById('main'+i) ) );
                    $('#main'+i).attr('codetip',codeList[i])
                }
                for(var i=0;i< elList.length;i++ ){
                    //   指定图表的配置项和数据
                    myChart[i].setOption(that.productAlterInfo[i]);
                    myChart[i].on('click', function (param) {
                        // series index 1 的系列中的 name 为 'xx' 的元素被 'mouseover' 时，此方法被回调。
                        // if(param.data.typeFlag == 'product'){
                        //   let params = {
                        //       type: 'product',
                        //       name: param.data.productName,
                        //       industry: param.data.industry,
                        //       productCode: param.data.productCode
                        //   }
                        //   that.addHistoryOpeParam(params)
                        //   ssUtil.setItem('searchSelectParam',params)
                        //   that.$router.push({name:'productInfo',params:params})
                        // }else if(param.data.typeFlag == 'company'){
                        //   let params = {
                        //       type: 'company',
                        //       coCode: param.data.coCode,
                        //       securityCode: param.data.securityCode,
                        //       name: param.data.securityName
                        //   }
                        //   let params1 = {
                        //       type: params.type,
                        //       coCode: params.coCode,
                        //       securityCode: param.data.securityCode,
                        //       name: params.name
                        //   }
                        //   that.addHistoryOpeParam(params1)
                        //   ssUtil.setItem('searchSelectParam',params)
                        //   that.$router.push({name:'productInfo',params:params})
                        // }
                        if(param.data.typeFlag == 'product') {
                            let params = {
                                type: 'company',
                                name: param.data.securityName,
                                coCode: param.data.coCode,
                                securityCode: param.data.securityCode
                            }
                            that.addHistoryOpeParam(params)
                            that.$router.push({name:'productInfo', params:params})
                        } else if(param.data.typeFlag == 'company') {
                            let params = {
                                type: 'product',
                                name: param.data.productName,
                                productCode: param.data.productCode,
                                industry: param.data.industry
                            }
                            that.addHistoryOpeParam(params)
                            that.$router.push({name:'productInfo', params:params})
                        }
                    });
                }
            })
        },
        //展示折线图
        showLine(){
            let that = this,elList=[],myChart = [],maxMinVal = {};
            // var myChart = this.$echarts.init(document.getElementById('mainLine'));
            this.indexSearchInfo.forEach(function( item ){
                let xData = [],seriesData = [];
                maxMinVal.max = item.maxValue;
                maxMinVal.min = item.minValue;
                item.seriesDataList.forEach(function(it){
                    xData.push(it.dataTime.split(' ')[0]),
                    seriesData.push(it.dataValue)
                })
                var option = {
                    title: {
                        left: 'center',
                        text: item.seriesName,
                        subtext: '下载数据',
                        sublink: baseUrl+'/user/downLoadSeriesData?seriesCode='+item.seriesCode+'&Authorization='+sessionStorage.getItem('authToken'),
                        subtarget:"blank",
                        subtextStyle:{//副标题内容的样式
                          color: '#d16c5d',
                          fontStyle:'normal',//主标题文字字体风格，默认normal，有italic(斜体),oblique(斜体)
                          fontWeight:"bold",//可选normal(正常)，bold(加粗)，bolder(加粗)，lighter(变细)，100|200|300|400|500...
                          fontFamily:"san-serif",//主题文字字体，默认微软雅黑
                          fontSize:12//主题文字字体大小，默认为12px
                        },

                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter: function (params) {
                            params = params[0];
                            return params.value+'<br />'+params.name;
                        },
                        axisPointer: {
                            animation: false
                        }
                    },
                    grid : {
                        containLabel:true
                    },
                    xAxis: {
                        type: 'category',
                        data: xData,
                        splitNumber:5,
                        axisLabel:{
                            rotate:30,
                        }
                    },
                    yAxis: {
                        type: 'value',
                        min: parseInt(maxMinVal.min<0?maxMinVal.min*1.2:maxMinVal.min*0.8),
                        max: parseInt(maxMinVal.max<0?maxMinVal.max*0.8:maxMinVal.max*1.2),
                        splitNumber:8
                    },
                    series: [{
                        name:item.seriesName,
                        type:'line',
                        smooth: true,
                        data:seriesData
                    }]
                };
                that.productLineInfo.push(option);
            })
            this.$nextTick(function(){
                elList = document.querySelectorAll('.productAlterBox>ul>li:not(:first-child)')
                for(var i=0;i< elList.length;i++ ){
                    myChart.push( that.$echarts.init(document.getElementById('mainLine'+i)));
                }
                for(var i=0;i< elList.length;i++ ){
                //   指定图表的配置项和数据
                    myChart[i].setOption(that.productLineInfo[i]);
                }
            })
        },
        //获取核心产业链
        getCoreProductChain(){
            this.$store.dispatch('getCoreProductChain',{coreName:this.coreName}).then( res => {
                this.productChain = res.data.data
                this.showChainGraph();
            })
        },
        //展示产业链关系图
        showChainGraph(){
            let that = this,elList=[],myChart = [],data = [],links = [];
            let color = ['#8f726c','#c26b71','#cf9087','#c18b67','#6a878d','#949784','#d5b57a','#889a80','#699f8f','#8797a7','#a37f7f','#cac1d4','#ededeb','#d4d5cd','#b7b1a5','#d8a09f','#dbdbd9','#abb7a1','#c1cbd7','#8696a7','#9ca8b8','#7a7281','#c9c0d3','#d8caaf','#d3d4cc'];
            this.productChain.baseData.forEach(function( item,index ){
                data.push({
                    value : item.name,
                    name : item.name,
                    // symbolSize : item.level<=4?30+(4-item.level)*10:40,
                    // symbolSize : [65,30],
                    symbolSize : 50,
                    chainName : item.name,
                    code : item.code,
                    itemStyle: {
                        normal: {
                            color: that.colorArr[item.level]
                            // color: color[index]
                        }
                    }
                })
            })
            links = this.productChain.relationData
            var option = {
                title: {text: ''},
                tooltip: {
                    show: true,
                    trigger: 'item'
                },
                animation:false,
                animationEasingUpdate: 'quinticInOut',
                series: [
                {
                    type: 'graph',
                    layout: 'force',
                    symbol: 'circle',
                    // symbolSize: 30,
                    draggable: true,
                    // roam: true,
                    label: {
                        normal: {
                            show: true,
                            fontWeight: 500,
                            fontSize: 16,
                            position:'top',
                            color:'#333',
                        }
                    },
                    force: {
                        // 力引导布局相关的配置项，力引导布局是模拟弹簧电荷模型在每两个节点之间添加一个斥力，每条边的两个节点之间添加一个引力，每次迭代节点会在各个斥力和引力的作用下移动位置，多次迭代后节点会静止在一个受力平衡的位置，达到整个模型的能量最小化。
                        // 力引导布局的结果有良好的对称性和局部聚合性，也比较美观。
                        repulsion: 845, // [ default: 50 ]节点之间的斥力因子(关系对象之间的距离)。支持设置成数组表达斥力的范围，此时不同大小的值会线性映射到不同的斥力。值越大则斥力越大
                        edgeLength: 150 // [ default: 30 ]边的两个节点之间的距离(关系对象连接线两端对象的距离,会根据关系对象值得大小来判断距离的大小)，
                        // 这个距离也会受 repulsion。支持设置成数组表达边长的范围，此时不同大小的值会线性映射到不同的长度。值越小则长度越长。如下示例:
                        // 值最大的边长度会趋向于 10，值最小的边长度会趋向于 50      edgeLength: [10, 50]
                    },
                    edgeSymbol: ['circle', 'arrow'],
                    edgeSymbolSize: [4, 10],
                    data: data,
                    tooltip: {
                        formatter: function(param) {
                            if (param.dataType === 'edge') {
                                return param.data.category;
                            }
                            return param.data.name;
                        },
                        backgroundColor: 'rgba(50,50,50,0.8)'
                    },
                    // edgeLabel: {                // 连接两个关系对象的线上的标签
                    //     normal: {
                    //             show: true,
                    //             textStyle: {
                    //                 fontSize: 16
                    //             },
                    //             formatter: function(param) {        // 标签内容
                    //                 return param.data.category;
                    //             }
                    //         }
                    // },
                    links: links,
                    lineStyle: {
                        normal: {
                            opacity: 0.5,
                            width: 1,
                            curveness: 0
                        }
                    }
                }
                ]
            };
            // 基于准备好的dom，初始化echarts实例
            this.$nextTick(function(){
                myChart = that.$echarts.init( document.getElementById('chain123'))
                myChart.setOption(option);
                myChart.on('click', function (param) {
                    if(param.data.source&&param.data.target){
                        return;
                    }
                    let productCode  =param.data.code
                    if(productCode=='0'){
                      return;
                    }
                    $(window).scrollTop($('[codetip='+productCode+']').offset().top)
                });
            })
        },
    },
    mounted() {
        this.getCoreProductChain();
        this.showLine();
        this.showGraph();
    },
  }
</script>

<style lang="scss" src="../sass/productAlter.scss"></style>



// WEBPACK FOOTER //
// src/components/productAlter.vue